import Button from "../Button";
import { useEffect, useState } from "react";

const TimerButton = ({ initialMinutes, initialSeconds, ...props }) => {
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const isDisabled = !(minutes === 0 && seconds === 0);

  return (
    <Button
      {...props}
      disabled={isDisabled || props?.disabled}
      handleClick={() => {
        if (props?.handleClick) props.handleClick();
        setSeconds(initialSeconds);
        setMinutes(initialMinutes);
      }}
      text={
        isDisabled
          ? `Resend in ${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
          : "Resend"
      }
    />
  );
};
export default TimerButton;
